import React, { Component, Fragment } from 'react'
import {
  Button,
} from "reactstrap";
import Moment from "react-moment";
import * as constants from "./constants"

export default class OrderCustomerInfo extends Component {
  render() {
    const {
      orderInfor,
      isLocking,
      msgLocking,
      isEditable,
      className,
      showMoreClass,
      isShowMoreContent,
    } = this.props

    const faIconBaseState = isShowMoreContent ? 'fa-caret-down' : 'fa-caret-up'

    return (
      <div className={`col-sm-12 ${className}`}>
        <div className="col-sm-12 mb-1 view-row">
          <span>Kho xuất: <b>{orderInfor.ten_kho}</b></span>
        </div>
        <div className="col-sm-12 mb-1 view-row">
          <span>Khách hàng: <b>{`${orderInfor.ten_khach_hang || ''}/${orderInfor.ma_khach_hang || ''}`}</b></span>
        </div>
        <div className="col-sm-12  mb-1 view-row">
          <span>Địa chỉ: <b>{orderInfor.dia_chi}</b></span>
        </div>
        <div className={`col-sm-12  mb-1 view-row ${showMoreClass}`}>
          <span>Điện thoại: <b>{orderInfor.dien_thoai}</b></span>
        </div>
        {this.props.typeOfOrder === constants.default.TYPEOF_ORDER.FOR_DEFAULT && (
          <Fragment>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Mã số thuế: <b>{orderInfor.ma_so_thue || ''}</b></span>
            </div>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>H/Đồng tham gia: <b>{orderInfor.hd_tham_gia}</b></span>
            </div>
          </Fragment>
        )}
        {orderInfor.ten_nguoi_sua && (
          <Fragment>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Người sửa: <b>{orderInfor.ten_nguoi_sua}</b></span>
            </div>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Ngày sửa: <b><Moment format="HH:mm DD/MM">{`${orderInfor.ngay_sua}`}</Moment></b></span>
            </div>
          </Fragment>
        )}
        {orderInfor.ten_nguoi_xu_ly && (
          <Fragment>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Người xử lý: <b>{orderInfor.ten_nguoi_xu_ly}</b></span>
            </div>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Ngày xử lý: <b><Moment format="HH:mm DD/MM">{`${orderInfor.ngay_xu_ly}`}</Moment></b></span>
            </div>
          </Fragment>
        )}
        {orderInfor.ten_nguoi_duyet && (
          <Fragment>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Người duỵệt: <b>{orderInfor.ten_nguoi_duyet}</b></span>
            </div>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Ngày duỵệt: <b><Moment format="HH:mm DD/MM">{`${orderInfor.ngay_duyet}`}</Moment></b></span>
            </div>
          </Fragment>
        )}
        {isLocking && (
          <div className="col-sm-12 mb-1 view-row">
            <span className="text-danger mr-1">{msgLocking}</span>&nbsp;
            {isEditable && (
              <Button className="btn btn-link mr-1" onClick={() => this.props.unlockOrder(orderInfor)}>
                Huỷ
              </Button>
            )}
          </div>
        )}
        <div title={'Click để xem thêm/bớt thông tin'} className={`col-sm-12 mb-1 order-show-button`} onClick={() => this.props.setShowHide()}>
          <span className={`fa ${faIconBaseState} fa-2x`}></span>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Order/_OrderCustomerInfo.js